import { useStaticQuery, graphql } from "gatsby"

const storyblokParseContent = (data) => data.edges
  .map(({node}) => {
    const content = JSON.parse(node.content)
    return { ...content, createdAt: node.created_at, uuid: node.uuid }
  })

const getUniqueSorted = (data, key) => {
  return [...new Set(
    data.map((i) => i[key]).flat().filter(Boolean)
  )].sort()
}

const useIndustryExpertsPartner = () => {
  const data = useStaticQuery(graphql`
		query IndustryExpertsQuery {
      creativeCommunityDesigns: allStoryblokEntry(
        filter: {field_component: {eq: "creativeCommunityDesign"}}
      ) {
        edges {
          node {
            uuid
            created_at
            content
          }
        }
      }
      eventsHubEventPartnerProfiles: allStoryblokEntry(
        filter: {
          field_component: {eq: "eventsHubEventPartnerProfile"}
          field_partnerType_string: {eq: "Industry Experts"}
        }
      ) {
        edges {
          node {
            uuid
            created_at
            content
          }
        }
      }
    }
  `);

  const creativeCommunityDesigns = storyblokParseContent(data.creativeCommunityDesigns)
  const profiles = storyblokParseContent(data.eventsHubEventPartnerProfiles)

  const partners = profiles.map(({
    getInTouchButtonLink, getInTouchButtonText, instagramProfileLink, learnMoreText,
    partnerDescription, partnerHeroImages, partnerLocation, partnerLogo,
    partnerName, twitterProfileLink, websiteLink, caseStudyButtonLink, caseStudyButtonText,
    facebookProfileLink, pinterestProfileLink, partnerSpeciality, partnerCountry,
    createdAt, contentful_id, partnerProfileUrlSlug, partnerType, communityProfileLink
  }) => ({
    getInTouchButtonLink,
    getInTouchButtonText,
    instagramProfileLink,
    learnMoreText,
    partnerDescription: { partnerDescription },
    partnerHeroImages: partnerHeroImages?.map((i) => ({
      file: { url: i.filename },
      title: i.title
    })),
    partnerLocation: {
      lat: partnerLocation?.lat,
      lon: partnerLocation?.lng
    },
    partnerLogo: {
      file: { url: partnerLogo?.filename },
      title: partnerLogo?.title
    },
    partnerName,
    twitterProfileLink,
    websiteLink,
    caseStudyButtonLink,
    caseStudyButtonText,
    facebookProfileLink,
    pinterestProfileLink,
    partnerSpeciality,
    partnerCountry,
    createdAt,
    contentful_id,
    partnerProfileUrlSlug,
    partnerType,
    communityProfileLink: communityProfileLink?.map(({ content: l }) => ({
      productType: l.productType,
      designTitle: l.designTitle,
      // designType: null, // MISSING IN DATA
      designStyle: l.designStyle,
      designsFiles: l.designsFiles.map((f) => ({
          file: { url: f.filename }
      })),
      designerProfile: {
        partnerLogo: {
          file: { url: partnerLogo?.filename },
        },
        partnerCountry,
        partnerName
      }
    }))
  })).filter((p) => !!p.partnerHeroImages && p.partnerHeroImages.length > 0)

  return {
    eventPartnersCountry: { distinct: getUniqueSorted(profiles, 'partnerCountry') },
    eventPartnerSpeciality: { distinct: getUniqueSorted(profiles, 'partnerSpeciality') },
    designStyle: { distinct: getUniqueSorted(creativeCommunityDesigns, 'designStyle') },
    eventPartners: { nodes: partners }
  }
}

export default useIndustryExpertsPartner;
